document.addEventListener('click', function(event) {
    const mediumHideDetails = document.querySelector('details.header-login.medium-hide');
    const largeUpHideDetails = document.querySelector('details.header-login.large-up-hide');
    if (mediumHideDetails && !mediumHideDetails.contains(event.target)) {
        mediumHideDetails.removeAttribute('open');
    }
    if (largeUpHideDetails && !largeUpHideDetails.contains(event.target)) {
        largeUpHideDetails.removeAttribute('open');
    }
});
